import { Component, Inject, ChangeDetectionStrategy } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";

@Component({
    templateUrl: 'dialog-campaign-cancel.html',
    styleUrls: ['./dialog-campaign-cancel.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [MatDialogModule, MatButtonModule]
})
  
  export class DialogCampaignCancel  {
    constructor(public dialogRef: MatDialogRef<DialogCampaignCancel>,
        @Inject(MAT_DIALOG_DATA) public data: {campaign: any}) { }
        
        onNoClick(campaign:any){ 
        this.dialogRef.close(campaign);
      }
  }